<template>
  <v-stepper v-model="virtualStepperStep" vertical>
    <v-stepper-step editable :step="6"
      >{{ $t(`${eventPrefix}.save.geo_blocking`) }}
      <small>{{ $t(`${eventPrefix}.save.step.geo_blocking.desc`) }}</small>
    </v-stepper-step>
    <v-stepper-content :step="6" :rules="[() => geo_blocking_validation]">
      <div class="pa-4">
        <v-form ref="geo_blocking">
          <v-card flat>
            <v-card-text>
              <v-layout row wrap>
                <!-- String -->
                <v-flex xs12 md10>
                  <h3
                    class="grey--text text--darken-3"
                    v-html="$t(`${eventPrefix}.save.geo_blocking.tooltip`)"
                  ></h3>
                </v-flex>
                <v-spacer></v-spacer>
                <!-- Conditional Remove button -->
                <v-flex
                  v-if="
                    (screener.geo_blocking.country_code &&
                      screener.geo_blocking.country_code.length) ||
                      (screener.geo_blocking.city &&
                        screener.geo_blocking.city.length)
                  "
                  xs12
                  md2
                  class="text-xs-right"
                >
                  <v-btn
                    class="ma-0"
                    color="error"
                    small
                    @click.stop="removeGeoBlocking"
                    >{{
                      $t(`${eventPrefix}.save.remove_blocking.button`)
                    }}</v-btn
                  >
                </v-flex>
              </v-layout>
              <GeoBlocking v-model="screener.geo_blocking"></GeoBlocking>
            </v-card-text>
          </v-card>
        </v-form>
        <v-card-actions>
          <v-btn color="secondary" dark @click="goToStep(7)">
            {{ $t(`${eventPrefix}.btn.continue`) }}
            <v-icon small>$vuetify.icons.screener_next</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </div>
    </v-stepper-content>
    <v-stepper-step v-if="!is_vod_event" editable step="7"
      >{{ $t("screener.save.step.seat_config") }}
      <small>{{ $t("screener.save.step.seat_config.desc") }}</small>
    </v-stepper-step>
    <v-stepper-content v-if="!is_vod_event" step="7">
      <v-form ref="seat_management">
        <div class="pa-4">
          <v-card-text>
            <v-alert
              v-if="
                !screener.id &&
                screener.screening_type == DEFINES.SCREENING_PLAN_TYPE.FREE
              "
              class="pa-2 mb-4"
              v-model="seatLimitAlert"
              color="primary"
              icon="info"
              outline
              dismissible
            >
              <h4
                class="font-weight-bold"
                v-html="$t(`${eventPrefix}.free_type.seats.tooltip`)"
              ></h4>
            </v-alert>
            <v-layout column>
              <v-flex xs12 md6 lg6>
                <v-text-field
                  class="mb-2"
                  id="limitation"
                  :label="$t(`${eventPrefix}.save.form.seats`)"
                  name="limitation"
                  :rules="
                    selected_company &&
                    selected_company.is_screening_pricing_enterprise
                      ? [
                          rules.required,
                          rules.inBetween(
                            1,
                            selected_company.max_allowed_seats,
                            screener.limitation
                          ),
                        ]
                      : [
                          rules.required,
                          rules.inBetween(
                            1,
                            DEFINES.PREMIUM_SCREENING_MAX_SEATS,
                            screener.limitation
                          ),
                        ]
                  "
                  color="primary"
                  prepend-icon="$vuetify.icons.rms_company_members"
                  type="text"
                  :readonly="
                    screener.screening_type !==
                    DEFINES.SCREENING_PLAN_TYPE.ENTERPRISE
                  "
                  v-model="screener.limitation"
                  :persistent-hint="screener.id ? true : false"
                  :hint="
                    screener.id &&
                    screener.screening_type !=
                      DEFINES.SCREENING_PLAN_TYPE.ENTERPRISE
                      ? userRoleInCompany >= DEFINES.ROLE_ADMIN
                        ? $t(
                            `${eventPrefix}.seats.update_limit_with_access.tip`,
                            {
                              button:
                                screener.screening_type ==
                                DEFINES.SCREENING_PLAN_TYPE.FREE
                                  ? $t(`${eventPrefix}.upgrade_now.title`)
                                  : $t(
                                      `${eventPrefix}.upgrade_free_plan.title`
                                    ),
                            }
                          )
                        : $t(
                            `${eventPrefix}.seats.update_limit_with_no_access.tip`
                          )
                      : ''
                  "
                  ><template v-slot:append>
                    <!-- Only company owner and admin can upgrade downgrade -->
                    <v-btn
                      v-if="
                        userRoleInCompany >= DEFINES.ROLE_ADMIN &&
                        screener.id &&
                        screener.screening_type !=
                          DEFINES.SCREENING_PLAN_TYPE.ENTERPRISE
                      "
                      depressed
                      tile
                      color="primary"
                      class="ma-0"
                      @click="$emit('update:seatsDialog',true)"
                    >
                      {{
                        screener.screening_type ==
                        DEFINES.SCREENING_PLAN_TYPE.FREE
                          ? $t(`${eventPrefix}.upgrade_now.title`)
                          : $t(`${eventPrefix}.upgrade_free_plan.title`)
                      }}
                    </v-btn>
                    <v-tooltip
                      v-if="
                        !screener.id &&
                        screener.screening_type ==
                          DEFINES.SCREENING_PLAN_TYPE.FREE
                      "
                      top
                      color="white"
                    >
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information-outline</v-icon>
                      </template>
                      <div
                        class="greyDarken3--text body-1"
                        v-html="$t(`${eventPrefix}.free_type.seats.tooltip`)"
                      ></div>
                    </v-tooltip>
                  </template>
                  ></v-text-field
                >
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="secondary"
              dark
              @click="goToStep(is_vod_event ? 7 : 8)"
            >
              {{ $t(`${eventPrefix}.btn.continue`) }}
              <v-icon small>$vuetify.icons.screener_next</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </div>
      </v-form>
    </v-stepper-content>
    <v-stepper-step
      :rules="[() => monetization_validation]"
      editable
      :step="is_vod_event ? 7 : 8"
      >{{ $t(`${eventPrefix}.save.step.monetization`) }}
      <small>{{ $t(`${eventPrefix}.save.step.monetization.desc`) }}</small>
    </v-stepper-step>
    <v-stepper-content :step="is_vod_event ? 7 : 8">
      <div class="pa-4">
        <v-form ref="monetization">
          <v-card flat>
            <v-card-text>
              <Monetization
                v-if="screener.id"
                :monetizationEnabled.sync="screener.monetization_enabled"
                :monetization.sync="screener.monetization"
                :isVodEvent="screener.is_vod_event"
                :hasReducedPriceBilling="screener.pricing_type == DEFINES.PREMIUM_SCREENING_PRICING_TYPE.REDUCED"
              ></Monetization>
              <PaypalDonation
                v-if="!screener.is_vod_event && !screener.monetization_enabled"
                :donation_enabled.sync="screener.donation_enabled"
                :donation.sync="screener.donation"
              />
            </v-card-text>
          </v-card>
        </v-form>
        <v-card-actions>
          <v-btn color="secondary" dark @click="goToStep(is_vod_event ? 8 : 9)">
            {{ $t(`${eventPrefix}.btn.continue`) }}
            <v-icon small>$vuetify.icons.screener_next</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </div>
    </v-stepper-content>
    <v-stepper-step editable :step="is_vod_event ? 8 : 9"
      >{{ $t(`${eventPrefix}.save.step.player_configuration`) }}
      <small>{{
        $t(`${eventPrefix}.save.step.player_configuration.desc`)
      }}</small>
    </v-stepper-step>
    <v-stepper-content :step="is_vod_event ? 8 : 9">
      <div class="pa-4">
        <v-card-text>
          <h3
            class="grey--text text--darken-3"
            v-html="$t(`${eventPrefix}.save.event_configuration.tooltip`)"
          ></h3>
          <EventConfiguration
            v-model="screener.event_configuration"
          ></EventConfiguration>
        </v-card-text>
         <v-card-actions>
          <v-btn color="secondary" dark @click="goToNextParentStep()" v-if="screener.event_type == DEFINES.SCREENER_TYPE.VIRTUAL_AND_PHYSICAL">
            {{ $t(`${eventPrefix}.btn.continue`) }}
            <v-icon small>$vuetify.icons.screener_next</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </div>
    </v-stepper-content>
  </v-stepper>
</template>
<script>
import DEFINES from "@/defines";
import rules from "@/validation";
import { buildHeaders } from "../../../api/_manager";
import DateTimePicker from "@/components/DateTimePicker";
import ShowLocalTime from "@/components/ShowLocalTime";
import TextEditor from "@/components/TextEditor";
import Monetization from "@/components/screener/monetization/Monetization";
import EventConfiguration from "@/components/screener/EventConfiguration";
import PaypalDonation from "@/components/screener/monetization/PaypalDonation";
import GeoBlocking from "@/components/screener/GeoBlocking";
import i18n from "@/i18n";

import { mapState, mapGetters } from "vuex";

import { tzToUtc } from "@/helper";
export default {
  name: "ScreenerVirtaulSave",
  props: {
    is_vod_event: {
      type: Boolean,
      default: false,
    },
    screener: {
      type: Object,
    },
    eventPrefix: {
      type: String,
      default: "screener",
    },
    screening_type: {
      type: Number,
      default: DEFINES.SCREENING_TYPE.SINGLE_FILM_SCREENING,
    },
    virtual_stepper_validation: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      virtualStepperStep: 6,
      rules,
      monetization_validation: true,
      copy_virtual_stepper_validation:this.virtual_stepper_validation,
      geo_blocking_validation: true,
      seatLimitAlert:false
    };
  },
  components: {
    DateTimePicker,
    ShowLocalTime,
    TextEditor,
    Monetization,
    PaypalDonation,
    EventConfiguration,
    GeoBlocking,
  },
  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected",
      selected_company: "getSelectedCompany",
    }),
    ...mapState({}),
    userRoleInCompany() {
      return this.$store.getters["company/userRoleInCompany"](
        this.selected_company_id
      );
    },
  },
  watch: {
    screener: {
      deep: true,
      handler: function () {
        this.$emit("update:screener", this.screener);
      },
    },
    copy_virtual_stepper_validation: {
      deep: true,
      handler: function () {
        this.$emit(
          "update:virtual_stepper_validation",
          this.copy_virtual_stepper_validation
        );
      },
    },
  },
  methods: {
    goToStep(step) {
      this.virtualStepperStep = step;
    },
    goToNextParentStep(){
      this.$emit("goToStep",3);
    },
    validateSave() {
      // Step 6 - Validate Geo Restriction
      if (!this.$refs.geo_blocking.validate()) {
        this.monetization_validation = 6;
        this.geo_blocking_validation = false;
        this.copy_common_stepper_validation = false;
        return false;
      } else {
        this.geo_blocking_validation = true;
      }
      // Step 8 - Validate Monetization
      if (!this.$refs.monetization.validate()) {
        this.monetization_validation = false;
        this.copy_virtual_stepper_validation = false;
        this.virtualStepperStep = this.is_vod_event ? 7 : 8;
        return false;
      } else {
        this.monetization_validation = true;
      }

      this.copy_virtual_stepper_validation = true;
      return true;
    },

     async removeGeoBlocking() {
      try {
        if (this.screener.id == undefined) {
          this.screener.geo_blocking = this.initializeGeoBlocking();
          return;
        }
        let response = await this.$store.dispatch(
          "screener/removeGeoBlocking",
          {
            id: this.screener.id,
          }
        );
        this.$store.dispatch("app/showMessage", {
          message: i18n.t(`${this.eventPrefix}.save.success.removedblocking`),
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
        });
        this.$emit("get");
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
  },
};
</script>
<style scoped>
</style>
